/* eslint-disable react/no-array-index-key */
import React, { ReactElement, useCallback, useEffect, useState } from 'react'
import cn from 'classnames'

import useEffectOnce from 'hooks/useEffectOnce'

import styles from './SlideButtons.module.css'

export type SlideButtonsProps = {
  steps?: number
  onChange?: (step: number) => void
  intervalSeconds?: number
  autoPlay?: boolean
}

const SlideButtons = ({
  steps = 3,
  onChange,
  intervalSeconds = 3,
  autoPlay = true,
}: SlideButtonsProps): ReactElement => {
  const [activeStep, setActiveStep] = useState(0)
  const [stopInterval, setStopInterval] = useState(false)

  let interval: NodeJS.Timeout
  useEffectOnce(() => {
    if (!stopInterval && autoPlay) {
      interval = setInterval(() => {
        setActiveStep((currentStep) => (currentStep + 1) % steps)
      }, intervalSeconds * 1000)
    }

    return () => clearInterval(interval)
  })

  const onClickStep = useCallback(
    (stepNumber: number) => {
      clearInterval(interval)
      setStopInterval(true)

      setActiveStep(stepNumber)
    },
    [interval],
  )

  useEffect(() => {
    if (onChange) {
      onChange(activeStep)
    }
  }, [activeStep, onChange])

  return (
    <div className={styles.container}>
      {Array(steps)
        .fill(0)
        .map((_, index) =>
          activeStep === index ? (
            <div
              onClick={() => onClickStep(index)}
              role="button"
              tabIndex={0}
              aria-label="Step"
              key={index}
              className={cn(styles.dot, styles.active)}
            />
          ) : (
            <div
              onClick={() => onClickStep(index)}
              role="button"
              tabIndex={0}
              aria-label="Step"
              key={index}
              className={styles.dot}
            />
          ),
        )}
    </div>
  )
}

export default SlideButtons
